import {Injectable} from '@angular/core';
import {MessageStream} from '../message-stream/message-stream';
import {ContactData} from '../../types/organization/contact-data';

@Injectable()
export class AddContactService extends MessageStream<ContactData> {
  constructor() {
    super();
  }
}
